import { axiosInstance } from '../../helpers/api_helper';

const updatePassword = async (formData: any) => {
  try {
    console.log('FormData in updatePassword:', formData);

    const response = await axiosInstance.patch(`/Vendor/UpdateVendorPassword`, formData);

    console.log('API Response from updatePassword:', response); // Log the response

    if (response.data.status === "00") {
      // Handle success, if needed
      return response.data;
    } else {
      // Handle error
      throw new Error('Error adding product');
    }
  } catch (error:any) {
    // Handle network or other errors
    throw new Error(`Error: ${error.message}`);
  }
};

export { updatePassword };
